import Base from "@/api/Base";

export default class Get extends Base
{
	setJobId (v)
	{
		this.jobId = v;
		return this;
	}

	setJobProfileId (v)
	{
		this.data.jobProfileId = v;
		return this;
	}

	getMethod ()
	{
		return 'GET';
	}

	getUrl ()
	{
		return '/job/' + this.jobId + '/vita';
	}
}